import { cleanCookie, getCookie, setCookie } from 'affiny-core/helpers/cookies';
import { IStorageServiceStrategy } from 'affiny-core/services/storage/storage';

export const SESSION_ORIGIN = 'session_origin';
const REMENC_KEY = 'remenc';
const PATH_OPTION = { path: '/' };

export class StorageWebStrategy implements IStorageServiceStrategy {
  public async persistRefreshToken(refreshToken: string) {
    return setCookie(REMENC_KEY, refreshToken, PATH_OPTION);
  }
  public async getRefreshToken() {
    return getCookie(REMENC_KEY) || null;
  }
  public async forgetRefreshToken() {
    return cleanCookie(REMENC_KEY, PATH_OPTION);
  }
  public persistSessionOrigin(sessionOrigin: string) {
    return sessionStorage.setItem(SESSION_ORIGIN, sessionOrigin);
  }
  public getSessionOrigin() {
    return sessionStorage.getItem(SESSION_ORIGIN);
  }
}
